import en from "@/plugins/localization/messages-en.js";
import sv from "@/plugins/localization/messages-sv.js";

export default {
  ...sv,
  ...en
}
